import React from "react";
import { css } from "@emotion/react";

const styles = css`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  height: 8px;
`;

const ColorDivider = () => {
  return (
    <div css={styles}>
      <div className="blue-bg"></div>
      <div className="green-bg"></div>
      <div className="yellow-bg"></div>
      <div className="pink-bg"></div>
    </div>
  );
};

export default ColorDivider;
